var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftArrowInWhite = function SvgLeftArrowInWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.428,
    cy: 27.391,
    rx: 27.428,
    ry: 27.391,
    transform: "rotate(179.838 27.464 27.427)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.134 18.379-9.117 9.156 9.169 9.104",
    stroke: "#023E11",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export { SvgLeftArrowInWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTUiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjI3LjQyOCIgY3k9IjI3LjM5MSIgcng9IjI3LjQyOCIgcnk9IjI3LjM5MSIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuOTk5OTk2IDAuMDAyNjI1OSAtMC4wMDI2MzMgLTAuOTk5OTk2IDU1LjAwMDYgNTQuNzgxNykiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMS4xMzM5IDE4LjM3ODlMMjIuMDE3MSAyNy41MzVMMzEuMTg1NiAzNi42Mzk1IiBzdHJva2U9IiMwMjNFMTEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";